import { FC } from "react";
import { UserProvider } from "./user-context";
import { Grid2 } from "@mui/material";
import { Layout } from "./layout";

export const App: FC = () => {
  return (
    <UserProvider>
      <Grid2 container height="100vh">
        <Layout />
      </Grid2>
    </UserProvider>
  );
};
